import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import PageModeAction from '../../actions/page-mode'

export const PageMode = {
    edit: 'edit',
    timeline: 'timeline',
    primary: 'primary'

}

export const PageModePropType = PropTypes.oneOf(['edit', 'timeline', 'primary'])

export default function withPageMode(ChildComponent) {

    class WithPageModeWrapper extends Component {
        static propTypes = {
            dispatch: PropTypes.func.isRequired,
            pageMode: PageModePropType.isRequired
        }

        constructor(props) {
            super(props)

            this.setPageMode = this.setPageMode.bind(this)
        }

        setPageMode(mode) {
            this.props.dispatch(PageModeAction.change(mode))
        }

        render() {
            const childProps = {
                setPageMode: this.setPageMode,
                ...this.props
            }

            return (
                <ChildComponent {...childProps} />
            )
        }
    }

    return connect(mapStateToProps)(WithPageModeWrapper)
}

const mapStateToProps = (state) => {
    const { pageMode } = state

    return {
        pageMode
    }
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-page-mode.js